import Vue from 'vue';
import Vuex from 'vuex';
import auth from '@/store/modules/auth';
import loading from '@/store/modules/loading';
import snackbar from '@/store/modules/snackbar';
import groupAuthorities from '@/store/modules/groupAuthorities';

import createPersistedState from 'vuex-persistedstate';
import SecureLS from 'secure-ls';
const ls = new SecureLS({ isCompression: false });

Vue.use(Vuex);

const store = new Vuex.Store({
  namespaced: true,
  modules: {
    loading,
    snackbar,
    groupAuthorities,
    auth,
  },
  plugins: [
    createPersistedState({
      paths: ['auth'],
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});

export default store;
